// extracted by mini-css-extract-plugin
export default {"inlineIcon":"InfoIconInline_inlineIcon__2Y7vz","icon":"InfoIconInline_icon__2w0JL"};